import { render, staticRenderFns } from "./ApexChartGeneral.vue?vue&type=template&id=d0d52d24&"
import script from "./ApexChartGeneral.vue?vue&type=script&lang=js&"
export * from "./ApexChartGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports